export default function SectionTabs({ active, completed }) {
  const sections = ["aptitude", "technical", "coding"];
  const completedIndex = sections.indexOf(completed);

  return (
    <div className="flex gap-4 border-b pb-4 mb-6">
      {sections.map((sec, i) => {
        const isActive = sec === active;
        const isLocked = i > completedIndex;

        return (
          <div
            key={sec}
            className={`px-5 py-2 rounded-md text-sm font-semibold
              ${
                isActive
                  ? "bg-blue-600 text-white"
                  : isLocked
                  ? "bg-gray-200 text-gray-400"
                  : "bg-green-100 text-green-700"
              }`}
            title={
              isLocked
                ? "Complete previous section to unlock"
                : "Section available"
            }
          >
            {sec.toUpperCase()}
          </div>
        );
      })}
    </div>
  );
}
